import Moderator from '@/models/bread/Moderator/accountTuition'

export default {
  key:'Tuition',
  server:'sso',
  name:{
    singular:'Tuition',
    plural:'Tuitions',
  },
  parents:[
    'Account',
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}